export class SearchState {
    query: string = "";
    isOpened: boolean = false;
}